export default {"src":"/_next/static/media/comment.ae5ecdc8.svg","height":16,"width":17,"blurWidth":0,"blurHeight":0};